import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  action,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6 md:mb-8">
      <div className="max-w-2xl">
        {eyebrow && (
          <div className="flex items-center gap-2 mb-2">
            <span className="w-6 h-[3px] rounded-full bg-accent-500" />
            <span className="text-xs font-medium tracking-[0.2em] uppercase text-accent-400">
              {eyebrow}
            </span>
          </div>
        )}
        <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950">
          {title}
        </h2>
        {description && (
          <p className="mt-2 text-sm md:text-base text-foreground-600 leading-relaxed">
            {description}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}